import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { z } from "zod";

interface UseGetFacilityTimeCardTemplateProps {
  facilityId: string;
}

const getFacilityTimeCardTemplateResponseSchema = z.object({
  distributionUrl: z.string(),
});

export type FacilityTimeCardTemplateResponse = z.infer<
  typeof getFacilityTimeCardTemplateResponseSchema
>;

export function useGetFacilityTimeCardTemplate(
  props: UseGetFacilityTimeCardTemplateProps,
  options?: UseGetQueryOptions<FacilityTimeCardTemplateResponse>
) {
  const { facilityId } = props;

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_API_MAIN_URL}/api/facilityprofile/${facilityId}/time-card-template`,
    responseSchema: getFacilityTimeCardTemplateResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_FACILITY_TIME_CARD_TEMPLATE_FAILURE,
    },
    retry: (_, error) => error.response?.status !== 404,
    refetchOnWindowFocus: false,
    ...options,
  });
}
